<template>
    <div>
        <v-snackbar
            v-for="(notif, key) in $notif.messages"
            :key="key"
            v-model="$notif.messages[key]"
            :color="notif.type"
            @change="change(key)"
            :timeout="notif.timeout"
            :multi-line="Boolean(notif.message)"
            top
        >
            {{ notif.title }}
            <br />
            {{ notif.message }}
            <v-btn text @click="change(key)" icon color="white">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import Vue from "vue"
export default {
    methods: {
        change(key) {
            this.$notif.delete(key)
        },
    },
}
</script>
